import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getMempoolBaseUrl(network: string): string {
  if (network.toLowerCase() === 'regtest') {
    return 'https://mempool.regtest.flashnet.xyz';
  }
  return 'https://mempool.space';
}

// Utility function to remove hyphens from transaction IDs
export const removeHyphens = (id: string): string => {
  return id.replace(/-/g, '');
};

// Function to ensure the ID has hyphens for the API call
export const addHyphens = (id: string): string => {
  const cleanedId = id.replace(/-/g, '');
  if (cleanedId.length !== 32) return id; // Return original if not 32 chars
  // Format: 8-4-4-4-12
  return `${cleanedId.slice(0, 8)}-${cleanedId.slice(8, 12)}-${cleanedId.slice(
    12,
    16
  )}-${cleanedId.slice(16, 20)}-${cleanedId.slice(20)}`;
};

export const hasHyphens = (id: string): boolean => {
  return id.includes('-');
};

export const getMempoolTxUrl = (txId: string, network: string): string => {
  const baseUrl = getMempoolBaseUrl(network);
  return `${baseUrl}/tx/${txId}`;
};

export const getMempoolAddressUrl = (address: string, network: string): string => {
  const baseUrl = getMempoolBaseUrl(network);
  return `${baseUrl}/address/${address}`;
};

// Calculate the effective transaction amount (excluding change outputs)
export function calculateEffectiveAmount(multiIoDetails: any): number {
  if (!multiIoDetails || !multiIoDetails.inputs || !multiIoDetails.outputs) {
    return 0;
  }

  // Get unique sender addresses
  const senderAddresses = new Set(multiIoDetails.inputs.map((input: any) => input.address));

  // Sum up outputs that don't go back to senders (non-change outputs)
  const effectiveAmount = multiIoDetails.outputs
    .filter((output: any) => !senderAddresses.has(output.address))
    .reduce((sum: number, output: any) => sum + output.amount, 0);

  return effectiveAmount;
}
